import type { JSX } from 'react'

import { SpinnerSC } from './Spinner.styled'

export const Spinner = (): JSX.Element => {
  return <SpinnerSC />
}
